import {
  defineTargetTableConfig,
  TargetTable,
  TargetTableProps,
} from 'components/DataExpansionComponents/Common/TargetTable/TargetTable'
import HospitalExportModal from 'components/Modals/ExportModal/HospitalExportModal'
import {
  getHospitalsSummaryForTable,
  listHospitalsForTable,
} from 'services/hospital'
import { HospitalsFilterset } from './HospitalsFilterset'
import { useHospitalsTableCols } from './hospitalsTableColumns'

const sortableFields: string[] = [
  'hospital_name',
  'total_hospital_beds',
  'total_hospital_days',
  'note_count',
  'contact_count',
  'deal_count',
  'street_addr',
  'city',
  'state',
  'zip_code',
  'provider_number',
  'cafeteria',
  'dietary',
  'dietary_under_contract',
  'sales_stages',
  'meals_per_day',
]

export const hospitalsTableConfig = defineTargetTableConfig({
  vertical: 'hospital',
  // Hospital detail link reads `hospital.id` (see hospitalsTableColumns name cell).
  rowConfig: { nestKey: 'hospital' },
  filterIdentifier: 'HOSPITAL_TABLE',
  savedPresetsIdentifier: 'HOSPITAL_TABLE',
  companyTypeSlug: 'healthcare-hospitals',
  tableTypeSlug: 'healthcare-hospitals',
  sortableFields,
  preferredGroupOrder: [
    'Target Attributes',
    'Campaigns and Deals',
    'Dining Services',
    'Hospital Insights',
  ],
  searchPlaceholder: 'Search hospitals by name',
  useColumns: useHospitalsTableCols,
  Filterset: HospitalsFilterset,
  ExportModal: HospitalExportModal,
  // Standalone openapi-codegen service fns (services/hospital) replaced the
  // legacy `api.getHospitalsList` / `api.getHospitalsSummary` hook methods on
  // dev — drop-in (same response shapes), so the resolver returns them directly.
  resolveLegacyActions: () => ({
    listAction: listHospitalsForTable,
    summaryAction: getHospitalsSummaryForTable,
  }),
})

export function HospitalsTable(
  props: Omit<TargetTableProps, 'AfterSearchComponent'>
) {
  return <TargetTable config={hospitalsTableConfig} {...props} />
}
